import type { ColumnDef } from "@tanstack/react-table"

import type { AgentExecution } from "@/types"

import AgentExecutionStatusBadge from "./agent-execution-status-badge"

function formatDateTime(dateString: string): string {
  const date = new Date(dateString)
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)
  const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate())

  const time = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  })

  if (dateOnly.getTime() === today.getTime()) {
    return `Today, ${time}`
  } else if (dateOnly.getTime() === yesterday.getTime()) {
    return `Yesterday, ${time}`
  } else {
    const month = date.toLocaleDateString("en-US", { month: "short" })
    const day = date.getDate()
    return `${month} ${day}, ${time}`
  }
}

export const agentExecutionColumns: ColumnDef<AgentExecution>[] = [
  {
    accessorKey: "created_at",
    header: "Time",
    cell: ({ row }) => {
      return (
        <div className="text-sm">{formatDateTime(row.original.created_at)}</div>
      )
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      return <AgentExecutionStatusBadge status={row.original.status} />
    },
  },
  {
    accessorKey: "summary",
    header: "Summary",
    cell: ({ row }) => {
      return <div className="text-sm">{row.original.summary || "-"}</div>
    },
  },
]
